import React from 'react';
import baseStyles from "./styles.module.css.js";
import { useStyleOverride } from "../../hooks/useStyleOverride.js";
export var NoResults = _ref => {
  var {
    message = 'No Results Found'
  } = _ref;
  var styles = useStyleOverride('results/NoResults', baseStyles);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.NoResults
  }, message);
};
export default NoResults;
//# sourceMappingURL=index.js.map